//                              Imports
// #############################################################
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Link } from 'react-router-dom';
// import './components.css';

const MiniPost = (props) => {
    const i = props.i;
    const post = props.post;
    const url = `${window.location.origin}/#/posts/${post.id}`;

    return (
        <tr key={post.id}>
            <th scope="row">{i + 1}</th>
            <td>{post.title}</td>
            <td>{url}</td>
            <td className="text-center">
                <CopyToClipboard text={url}>
                    <button className="copy-btn">
                        <i className="material-icons">content_copy</i>
                    </button>
                </CopyToClipboard>
            </td>
            <td className="text-center">
                <Link className="links" to={`/posts/${post.id}`}>
                    Bekijk
                </Link>
            </td>
        </tr>
    );
};

export default MiniPost;
